export const CHAT_STATUS = {
  DISCONNECTED: 'DISCONNECTED',
  SUPPORT: 'SUPPORT',
  ACTIVE: 'ACTIVE',
}
